<script>
import ModalServico from '@modal/salvar-servico'
import ModalCadastroClientes from '@modal/ModalCadastroClientes'
import ModalAporteResgate from '@modal/salvar-aporte-resgate'
import ModalSelectClient from '@modal/select-client'
import ModalRegisterProfessional from '@modal/register-new-professional'
import ModalEnviarPush from '@modal/send-push'
import ModalValidarEmail from '@modal/validar-email'
import ModalSeeMoreService from '@modal/modal-see-more-service'
import ModalSendComunicate from '@modal/send-comunicate'
import ModalCarteiraAnalise from '@modal/modal-carteira-analise'
import ModalMinhaCarteira from '@modal/modal-minha-carteira'
import ModalSimuladorAnalise from '@modal/workspace/simulador-analise'
import ModalSimuladorComparativo from '@modal/workspace/simulador-comparativo'
import ModalSettingsDailyTasks from '@modal/settings-daily-tasks'
import ServiceFilter from '@modal/service-filter'
import { MODAL, RELOAD, RUNNING, STOP, FEATURES } from '@constants/Text'
import Vue from 'vue'
import InserirToken from '@modal/inserir-token'
import { possivelJSON } from '@utils/Format'
import store from '@state/store'
import con from '@services/connection'
import { atualizar, adicionarTransacao } from '@constants/URL'
import CadastroConta from '@modal/cadastro-conta-investimento'
import SendLink from '@modal/send-link-services'
import { GlobalBus } from '@services/bus'
import TourTemporario from '@modal/tour-temporario.vue'
import { funcaoIndisponivel } from '@utils/Whitelabel'

export default {
  components: {
    ModalServico,
    ModalCadastroClientes,
    ModalAporteResgate,
    ModalEnviarPush,
    ModalValidarEmail,
    ModalSeeMoreService,
    ModalSendComunicate,
    ModalSettingsDailyTasks,
    ModalSelectClient,
    CadastroConta,
    ModalCarteiraAnalise,
    ModalMinhaCarteira,
    ModalSimuladorAnalise,
    ModalSimuladorComparativo,
    SendLink,
    InserirToken,
    ServiceFilter,
    ModalRegisterProfessional,
    TourTemporario,
  },
  data() {
    return {
      banks_token: [],
      checkAtualizandoLoading: false,
      _pollingCancelled: false,
      pollingTimerAtualizando: null,
      pollingTimerToken: null,
      pollingTimerCotization: null,
      busModal: new Vue(),
      isWhitelabel: WHITELABEL,
      hoverAtualizar: false,
      hoverComunicacao: false,
      hoverPortabilidade: false,
      hoverCadastro: false,
      hoverCotizar: false,
      hoverSimulador: false,
      hoverMercado: false,
      hoverComoFazer: false,
      loadingAtualizar: false,
      loadingAttCI: false,
      requestToken: [],
      contas_automaticas: [],
      menusCliente: {
        Cadastro: [
          {
            title: 'Ativo',
            action: this.openCadastrarAtivos,
          },
          {
            title: 'Conta',
            action: this.openContaInvestimento,
          },
          {
            title: 'Aporte/Resgate',
            action: this.openAporteResgate,
          },
        ],
        Portabilidade: [],
        Atualizar: [
          {
            title: 'Rentabilidade',
            action: this.openEnviarAtt,
          },
          {
            title: 'Contas de investimentos',
            action: this.attBanks,
          },
        ],
        // Cotizar: [
        //   {
        //     title: 'Informações Faltantes',
        //     action: this.isBeta,
        //   },
        // ],
        Mercado: [
          // { title: 'Notícias', action: this.openMarketWindow },
          // { title: 'Fundos', action: this.openMarketWindow },
          // { title: 'Ações', action: this.openMarketWindow },
        ],
      },
      menusProfissional: {
        Cadastro: [
          {
            title: 'Clientes',
            action: this.openCadastrarClientes,
          },
          {
            title: 'Serviço',
            action: this.openCadastrarServicos,
          },
          {
            title: 'Ativo',
            action: this.openCadastrarAtivos,
          },
          {
            title: 'Aporte/Resgate',
            action: this.openAporteResgate,
          },
        ],
        Comunicacao: [
          // {
          //   title: 'E-mail',
          //   action: this.isBeta,
          // },
          {
            title: 'Notificação',
            action: this.openEnviarPush,
          },
          {
            title: 'Comunicado',
            action: this.openSendComunicate,
          },
        ],
        Portabilidade: [],
        Atualizar: [],
        // Cotizar: [
        //   {
        //     title: 'Informações Faltantes',
        //     action: this.isBeta,
        //   },
        // ],
        Simulador: [
          { title: 'Manual', action: this.openSimuladorManual },
          { title: 'Automático', action: this.openSimuladorAutomatico },
          { title: 'Guiado', action: this.openSimuladorGuiado },
          { title: 'Avançado', action: this.openSimuladorAvancado },
        ],
        Mercado: [
          // { title: 'Notícias', action: this.openMarketWindow },
          // { title: 'Fundos', action: this.openMarketWindow },
          // { title: 'Ações', action: this.openMarketWindow },
        ],
        'Primeiros Passos': [
          {
            title: 'Como fazer',
            action: this.openComoFazer,
          },
          {
            title: 'FAQ',
            action: this.openFaq,
          },
          {
            title: 'Fale conosco',
            action: this.openFaleConosco,
          },
        ],
      },
      menusGestor: {
        Cadastro: [
          {
            title: 'Clientes',
            action: this.openCadastrarClientes,
          },
          {
            title: 'Serviço',
            action: this.openCadastrarServicos,
          },
          {
            title: 'Ativo',
            action: this.openCadastrarAtivos,
          },
          {
            title: 'Aporte/Resgate',
            action: this.openAporteResgate,
          },
          {
            title: 'Profissionais',
            action: this.openProfissionais,
          },
        ],
        Comunicacao: [
          // {
          //   title: 'E-mail',
          //   action: this.isBeta,
          // },
          {
            title: 'Notificação',
            action: this.openEnviarPush,
          },
          {
            title: 'Comunicado',
            action: this.openSendComunicate,
          },
        ],
        Portabilidade: [],
        Atualizar: [],
        // Cotizar: [
        //   {
        //     title: 'Informações Faltantes',
        //     action: this.isBeta,
        //   },
        // ],
        Simulador: [
          { title: 'Manual', action: this.openSimuladorManual },
          { title: 'Automático', action: this.openSimuladorAutomatico },
          { title: 'Guiado', action: this.openSimuladorGuiado },
          { title: 'Avançado', action: this.openSimuladorAvancado },
        ],
        Mercado: [
          // { title: 'Notícias', action: this.openMarketWindow },
          // { title: 'Fundos', action: this.openMarketWindow },
          // { title: 'Ações', action: this.openMarketWindow },
        ],
        'Primeiros Passos': [
          {
            title: 'Como fazer',
            action: this.openComoFazer,
          },
          {
            title: 'FAQ',
            action: this.openFaq,
          },
          {
            title: 'Fale conosco',
            action: this.openFaleConosco,
          },
        ],
      },
    }
  },
  computed: {
    client() {
      return store.getters['user/currentClient'] || {}
    },
    menu() {
      let hasMenuServico = this.menusProfissional['Cadastro'].find((v, i) => {
        return v.title == 'Serviço'
      })
      if (
        this.usuarioAtual.IS_ASSESSOR &&
        this.isWhitelabel &&
        !this.usuarioAtual.IS_GESTOR &&
        hasMenuServico
      ) {
        this.menusProfissional['Cadastro'] = this.menusProfissional[
          'Cadastro'
        ].filter((v, i) => {
          return v.title !== 'Serviço'
        })
        return this.menusProfissional
      }
      return this.usuarioAtual.IS_CLIENTE
        ? this.menusCliente
        : this.usuarioAtual.IS_GESTOR
        ? this.menusGestor
        : this.menusProfissional
    },
    usuarioAtual() {
      return store.getters['user/currentUser'] || {}
    },
  },
  created() {
    this.getContasAutomaticas()
  },
  mounted() {
    this.busModal.$on('token-bank', this.updateOnToken)
    GlobalBus.$on(RUNNING.ATUALIZAR_BANCOS, this.attBanks)
    GlobalBus.$on(RUNNING.ATUALIZAR_BANCO, this.attBank)
    GlobalBus.$on(MODAL.LEFT_ACTION, this.doAction)
  },
  beforeDestroy() {
    this._pollingCancelled = true
    clearTimeout(this.pollingTimerAtualizando)
    clearTimeout(this.pollingTimerToken)
    clearTimeout(this.pollingTimerCotization)
    this.busModal.$off('token-bank', this.updateOnToken)
    this.busModal.$destroy()
    GlobalBus.$off(RUNNING.ATUALIZAR_BANCOS, this.attBanks)
    GlobalBus.$off(RUNNING.ATUALIZAR_BANCO, this.attBank)
    GlobalBus.$off(MODAL.LEFT_ACTION, this.doAction)
  },
  methods: {
    needWhitelabel() {
      funcaoIndisponivel(this)
    },
    doAction(func, ...args) {
      if (this[func] && typeof this[func] === 'function') {
        this[func](...args)
      }
    },
    updateOnToken(v) {
      console.log('Banco e token...', v)
      this.attBank(v, v.token)
    },
    isBeta() {
      this.$showSnack({
        text: 'Função em desenvolvimento',
        button: true,
      })
    },
    openSendLink() {
      // lugar do ' ' colocar um serviço { id_servico: Integer, nome_servico: String } caso deseje pular etapa de escolher serviço
      this.busModal.$emit(MODAL.SEND_LINK, '')
    },
    openCadastrarServicos() {
      this.busModal.$emit(MODAL.CADASTRAR_SERVICOS, true)
    },
    openCadastrarClientes() {
      this.busModal.$emit(MODAL.CADASTRAR_CLIENTES, true)
    },
    openCadastrarAtivos() {
      // this.busModal.$emit('modal_cadastrar_ativo', true)
      GlobalBus.$emit(MODAL.CONSOLIDADOR_REGISTER_ASSET, {})
    },
    openAporteResgate() {
      // this.busModal.$emit('modal_aporte_resgate', true)
      this.busModal.$emit(MODAL.SELECIONAR_CLIENTE, MODAL.CADASTRAR_APORTE)
    },
    openValidarEmail() {
      this.busModal.$emit(MODAL.VALIDAR_EMAIL, true)
    },
    openContaInvestimento() {
      this.busModal.$emit(MODAL.CADASTRAR_CONTA, true)
    },
    openServiceFilter() {
      this.busModal.$emit(MODAL.FILTRO_SERVICOS, true)
    },
    openEnviarPush() {
      this.busModal.$emit(MODAL.SELECIONAR_CLIENTE, MODAL.SEND_PUSH)
    },
    openSendComunicate() {
      GlobalBus.$emit(MODAL.SEND_COMUNICATE, true)
    },
    openSimulador() {
      if (!this.isWhitelabel) {
        this.needWhitelabel()
        return
      }
      if (!this.$store.getters['parameters/canShow'](FEATURES.SIMULADOR)) {
        this.$showSnack({
          text: 'Você não tem permissão para acessar o simulador',
          button: true,
        })
        return
      }
      const name = 'simulador.selecionar'
      if (this.$route.name != name) {
        if (this.$currentClient().name) {
          this.$router.push({ name })
          return
        }
        GlobalBus.$emit(
          MODAL.SELECIONAR_CLIENTE,
          'abrir_pagina_simulador.selecionar',
          { select_cliente: true }
        )
      }
    },
    openSimuladorManual() {
      if (!this.isWhitelabel) {
        this.needWhitelabel()
        return
      }
      if (!this.$store.getters['parameters/canShow'](FEATURES.SIMULADOR)) {
        this.$showSnack({
          text: 'Você não tem permissão para acessar o simulador',
          button: true,
        })
        return
      }
      const name = 'simulador.manual'
      if (this.$route.name != name) {
        // this.$router.push({ name })
        GlobalBus.$emit(
          MODAL.SELECIONAR_CLIENTE,
          'abrir_pagina_simulador.manual',
          { select_cliente: true }
        )
      }
    },
    openSimuladorAutomatico() {
      if (!this.isWhitelabel) {
        this.needWhitelabel()
        return
      }
      if (!this.$store.getters['parameters/canShow'](FEATURES.SIMULADOR)) {
        this.$showSnack({
          text: 'Você não tem permissão para acessar o simulador',
          button: true,
        })
        return
      }
      const name = 'simulador.automatico'
      if (this.$route.name !== name) {
        // this.$router.push({ name })
        GlobalBus.$emit(
          MODAL.SELECIONAR_CLIENTE,
          'abrir_pagina_simulador.automatico',
          { select_cliente: true }
        )
      }
    },
    openSimuladorGuiado() {
      if (!this.isWhitelabel) {
        this.needWhitelabel()
        return
      }
      if (!this.$store.getters['parameters/canShow'](FEATURES.SIMULADOR)) {
        this.$showSnack({
          text: 'Você não tem permissão para acessar o simulador',
          button: true,
        })
        return
      }
      const name = 'simulador.guiado'
      if (this.$route.name != name) {
        // this.$router.push({ name })
        GlobalBus.$emit(
          MODAL.SELECIONAR_CLIENTE,
          'abrir_pagina_simulador.guiado',
          { select_cliente: true }
        )
      }
    },
    openSimuladorAvancado() {
      if (!this.isWhitelabel) {
        this.needWhitelabel()
        return
      }
      if (!this.$store.getters['parameters/canShow'](FEATURES.SIMULADOR)) {
        this.$showSnack({
          text: 'Você não tem permissão para acessar o simulador',
          button: true,
        })
        return
      }
      const name = 'simulador.avancado'
      if (this.$route.name !== name) {
        // this.$router.push({ name })
        GlobalBus.$emit(
          MODAL.SELECIONAR_CLIENTE,
          'abrir_pagina_simulador.avancado',
          { select_cliente: true }
        )
      }
    },
    checkAtualizando() {
      if (!this.usuarioAtual.IS_CLIENTE) {
        return
      }
      if (this.checkAtualizandoLoading) {
        return
      }
      this.checkAtualizandoLoading = true
      con.get(adicionarTransacao.bancos.contas_cliente).then((r) => {
        this.checkAtualizandoLoading = false
        if (r && r.status === 200) {
          let has_updating, has_error

          if (this.accountAtt) {
            this.accounts = possivelJSON(r.value).filter((v, i) => {
              return v.id_conta == this.accountAtt
            })
            has_updating = this.accounts[0].status === 'Atualizando'
            has_error =
              this.accounts[0].status != 'ok' &&
              this.accounts[0].status != 'Atualizando' &&
              this.accounts[0].status != 'Aguardando confirmação'
          } else {
            this.accounts = possivelJSON(r.value).filter((v, i) => {
              return v.codigo != -1
            })
            has_updating = this.accounts.find((v, i) => {
              return v.codigo != -1 && v.status === 'Atualizando'
            })
            has_error = this.accounts.find((v, i) => {
              return (
                v.codigo != -1 &&
                v.status != 'ok' &&
                v.status != 'Atualizando' &&
                v.status != 'Aguardando confirmação'
              )
            })
          }

          this.preencherContas(r)

          if (has_updating) {
            this.pollingTimerAtualizando = setTimeout(() => {
              if (!this._pollingCancelled) this.checkAtualizando()
            }, 8000)
          } else {
            if (this.$route.name != 'contas') {
              this.$showSnack({
                text: has_error
                  ? 'Não conseguimos atualizar todas as contas'
                  : 'Contas atualizadas',
                button: {
                  text: 'Ver',
                  callback: () => {
                    if (this.$route.name != 'contas') {
                      this.$router.push({ name: 'contas' })
                    }
                  },
                },
              })
            }
            this.loadingAttCI = false
            this.accountAtt = false
          }
        }
      })
    },
    async getContasAutomaticas() {
      if (!this.usuarioAtual.IS_CLIENTE) {
        return
      }
      const res = await con.get(adicionarTransacao.bancos.contas_cliente)
      if (res && res.status == 200) {
        const acc = possivelJSON(res.value).find((c) => {
          return c.status === 'Atualizando' && c.codigo != -1
        })
        if (acc) {
          this.checkAtualizando()
        }
        this.preencherContas(res)
      }
      store.dispatch('user/checkIncompleteAsset')
    },
    preencherContas(r) {
      let contas = possivelJSON(r.value)

      contas = contas.filter((v) => {
        return v.codigo != -1
      })

      this.contas_automaticas = contas.filter((v, i) => {
        return v.id_banco
      })
      this.banks_token = this.contas_automaticas.filter((v, i) => {
        return (
          v.requisitos.includes('token') &&
          v.status != 'Atualizando' &&
          v.is_valid
        )
      })
    },
    attBank(bank, token) {
      if (!bank.is_valid) {
        return
      }
      if (bank.requisitos.includes('token') && bank.is_valid && !token) {
        this.requestToken = [bank]
        this.openInserirToken(bank)
        return
      }
      con
        .post(adicionarTransacao.bancos.att, {
          codigo_banco: bank.codigo,
          id_banco: bank.id_banco,
          token: token === 'NULL' ? '' : token,
          id_conta: bank.id_conta,
          async: false,
        })
        .then((res) => {
          if (res && res.status == 200) {
            this.token = ''
            this.getContasAutomaticas()
            this.accountAtt = bank.id_conta
            GlobalBus.$emit('attOneBank', bank.id_conta)
            this.banks_token = this.banks_token.filter((b) => {
              return b.id_conta != bank.id_conta
            })
            if (this.banks_token.length) {
              this.loadingAttCI = false
              // this.attBanks()
            }
            GlobalBus.$emit(RELOAD.ATT_BANKS)
          }
        })
    },
    attBanks() {
      if (this.usuarioAtual.IS_CLIENTE) {
        if (this.loadingAttCI) {
          return
        }
        this.loadingAttCI = true
        const data = {
          manual: true,
        }
        con.post(adicionarTransacao.bancos.crawlers, data).then((res) => {
          if (res && res.status == 200) {
            this.requestToken = Object.values(res.value.value).filter((b) => {
              return (
                b.is_valid &&
                b.status === 'token' &&
                this.banks_token
                  .map((v, i) => {
                    return v.nome
                  })
                  .includes(b.nome_banco)
              )
            })
            this.requestNextToken()
          }
        })
      }
    },
    requestNextToken() {
      if (this.requestToken.length) {
        this.pollingTimerToken = setTimeout(() => {
          if (this._pollingCancelled) return
          let bank = this.requestToken.reverse().pop()
          bank = this.contas_automaticas.find((c) => {
            return c.id_conta == bank.id_conta
          })
          this.banks_token = this.contas_automaticas.filter((c) => {
            return (
              c.requisitos.includes('token') &&
              c.status != 'Atualizando' &&
              c.is_valid
            )
          })
          if (bank) {
            this.openInserirToken(bank)
          } else {
            this.requestNextToken()
          }
        }, 500)
      } else {
        this.loadingAttCI = false
        GlobalBus.$emit(RELOAD.ATT_BANKS)
      }
    },
    openInserirToken(bank) {
      this.busModal.$emit(MODAL.TOKEN, true, true)
      this.busModal.$emit('bank-account', bank)
    },
    atualizarAll() {
      this.attBanks()
      this.openEnviarAtt()
    },
    async openEnviarAtt() {
      if (this.loadingAtualizar) {
        return
      }
      if (this.usuarioAtual.IS_CLIENTE) {
        this.loadingAtualizar = true
        GlobalBus.$emit(RUNNING.COTIZACAO)
        const r = await con.get(atualizar.run)
        if (r && r.status === 200) {
          this.$showSnack({
            text: r.message,
            button: true,
          })
          setTimeout(() => {
            this.checkStatusCotization()
          }, 10000)
        } else {
          this.$showSnack({
            text: r.message,
            button: true,
          })
          this.loadingAtualizar = false
          GlobalBus.$emit(STOP.COTIZACAO)
          GlobalBus.$emit(RELOAD.ASSETS)
        }
      } else {
        this.busModal.$emit(MODAL.SELECIONAR_CLIENTE, MODAL.SEND_PUSH, 'att')
      }
    },
    async checkStatusCotization() {
      const r = await con.get(atualizar.status)
      if (r && r.status === 200) {
        if (r.value.atualizando) {
          this.pollingTimerCotization = setTimeout(() => {
            if (!this._pollingCancelled) this.checkStatusCotization()
          }, 10000)
          return
        }
        GlobalBus.$emit(RELOAD.ASSETS)
      }
      this.$showSnack({
        text: r.message,
        button: true,
      })
      this.loadingAtualizar = false
      GlobalBus.$emit(STOP.COTIZACAO)
    },
    openPortabilidade() {
      GlobalBus.$emit(MODAL.SELECIONAR_CLIENTE, MODAL.PORTABILIDADE, true)
    },
    openMarketWindow() {
      const w = window.screen.availWidth
      const h = window.screen.availHeight
      const url =
        (process.env.NODE_ENV === 'production' ? '/investimentos/' : '') +
        'mercado'
      window.open(url, '_blank', `height=${h / 1.5},width=${w - 100}`)
    },
    openProfissionais() {
      this.busModal.$emit(MODAL.REGISTER_PROFESSIONAL, true)
    },
    openComoFazer() {
      this.busModal.$emit(MODAL.TOUR_TEMPORARIO, true)
    },
    openFaq() {
      this.$router.push({
        name: 'suporte.faq',
      })
    },
    openFaleConosco() {
      this.$router.push({
        name: 'suporte.fale_conosco',
      })
    },
  },
}
</script>

<template>
  <div id="left-bar" style="width: 100%; min-height: 100%">
    <div>
      <slot :busLeft="busModal" />

      <TourTemporario :bus="busModal" />
      <ServiceFilter :bus="busModal" />
      <ModalRegisterProfessional :bus="busModal" />
      <SendLink :bus="busModal" />
      <ModalServico :bus="busModal" />
      <ModalCadastroClientes :bus="busModal" />
      <ModalValidarEmail :bus="busModal" />
      <ModalAporteResgate :bus="busModal" />
      <ModalEnviarPush :bus="busModal" />
      <ModalSelectClient :bus="busModal" />
      <CadastroConta :bus="busModal" />

      <ModalCarteiraAnalise :bus-left="busModal" />
      <ModalMinhaCarteira :bus-left="busModal" />
      <ModalSimuladorAnalise :bus-left="busModal" />
      <ModalSimuladorComparativo :bus-left="busModal" />

      <InserirToken :bus="busModal"> </InserirToken>
      <ModalSeeMoreService :bus="busModal" />
      <ModalSendComunicate :bus="busModal" />
      <ModalSettingsDailyTasks :bus="busModal" />
    </div>
  </div>
</template>

<style lang="sass" scoped>
@import '@design/components/_aside.sass'

.white-hover:hover
  color: var(--secondary) !important
  caret-color: var(--secondary) !important

.hover-dark
  &.v-list-item:hover:before
    opacity: .05!important
    background: var(--v-primary-base)
  &.v-list-item:hover
    opacity: 1!important
    background-color: var(--v-primary-base) !important

@media print
  .dont-show-print
    display: none
</style>
